const hasMeaningfulValue = (value: unknown): boolean => (
  value !== null
  && value !== undefined
  && (typeof value !== 'string' || value.trim() !== '')
);

/**
 * Preserve properties learned while expanding the graph, but do not let an
 * older empty value hide a meaningful value from the latest graph response.
 */
export const mergeGraphNodeProperties = (
  incoming: Record<string, unknown> | null | undefined,
  existing: Record<string, unknown> | null | undefined,
): Record<string, unknown> => {
  const incomingProperties = incoming ?? {};
  const existingProperties = existing ?? {};
  const mergedProperties = { ...incomingProperties, ...existingProperties };

  Object.entries(incomingProperties).forEach(([key, value]) => {
    if (!hasMeaningfulValue(existingProperties[key]) && hasMeaningfulValue(value)) {
      mergedProperties[key] = value;
    }
  });

  return mergedProperties;
};
